import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { CircularProgress } from "@mui/material";
import { loginRequest } from "../../authConfig";
import DataTable from "../../components/DataTable/DataTable";

export const Dashboard = () => {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length === 0) {
      instance.initialize()
        .then(() => instance.loginRedirect(loginRequest))
        .catch(e => {
          console.error(e);
        });
    }
  }, [instance, accounts.length]);


  return (
    <>
      {accounts.length === 0 ? (
        <div className='loader-overlay'>
          <CircularProgress />
        </div>
      ) : (
        <DataTable />
      )}
    </>
  )
};